import { render } from "./AddNewTagModal.vue?vue&type=template&id=14ba1eb2&ts=true"
import script from "./AddNewTagModal.vue?vue&type=script&lang=ts"
export * from "./AddNewTagModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__